import React, { forwardRef } from "react";

import { cn } from "./cn";

/* ── Select component ────────────────────────────────────── */

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, error = false, children, ...props }, ref) => {
    return (
      <select
        ref={ref}
        className={cn(
          "rounded-lg border bg-surface px-3 py-2 text-sm text-ink focus:outline-none focus:ring-2 focus:ring-accent",
          error ? "border-red-500" : "border-edge",
          className,
        )}
        aria-invalid={error || undefined}
        {...props}
      >
        {children}
      </select>
    );
  },
);

Select.displayName = "Select";

export { Select };
export type { SelectProps };
